export { default as translations } from './translations.json';

/**
 * Check if user has an active membership.
 * @param {Object|null} user
 * @returns {boolean}
 */
export const hasMembership = (user) => {
  const m = user?.attributes?.protectedData?.membership;
  if (!m || m.status !== 'active') return false;
  if (m.expiresAt && new Date(m.expiresAt) < new Date()) return false;
  return true;
};

/**
 * Check if listing requires membership.
 * @param {Object|null} listing
 * @returns {boolean|string} — false or plan name
 */
export const listingRequiresMembership = (listing) =>
  listing?.attributes?.publicData?.requiresMembership || false;

/**
 * Check if user can access a gated listing.
 * @param {Object|null} user
 * @param {Object|null} listing
 * @returns {boolean}
 */
export const canAccessListing = (user, listing) => {
  const required = listingRequiresMembership(listing);
  if (!required) return true;
  if (!hasMembership(user)) return false;
  if (typeof required === 'string') {
    return user?.attributes?.protectedData?.membership?.plan === required;
  }
  return true;
};
